export default {
  site_name: '龙禁漫',
  site_description: '正版漫画资源平台',
  nav_home: '首页',
  nav_category: '分类浏览',
  nav_about: '关于我们',
  start_reading: '开始阅读',
};